<template>
  <path
    fill="currentColor"
    d="M5.20876 12.995L16.3788 12.995L11.4988 17.875C11.1088 18.265 11.1088 18.905 11.4988 19.295C11.6856 19.4823 11.9392 19.5875 12.2038 19.5875C12.4683 19.5875 12.7219 19.4823 12.9088 19.295L19.4988 12.705C19.8888 12.315 19.8888 11.685 19.4988 11.295L12.9088 4.70504C12.5188 4.31504 11.8888 4.31504 11.4988 4.70504C11.1088 5.09504 11.1088 5.72504 11.4988 6.11504L16.3788 10.995L5.20876 10.995C4.65876 10.995 4.20876 11.445 4.20876 11.995C4.20876 12.545 4.65876 12.995 5.20876 12.995Z"
  />
</template>
